// header search input text animation JS
class TypeWriter {
  constructor(txtElement, words, wait = 3000) {
    this.txtElement = txtElement;
    this.words = words;
    this.txt = '';
    this.wordIndex = 0;
    this.wait = parseInt(wait, 8);
    this.type();
    this.isDeleting = false;
  }

  type() {
    // Current index of word
    const current = this.wordIndex % this.words.length;
    // Get full text of current word
    const fullTxt = this.words[current];

    // Check if deleting
    if(this.isDeleting) {
      // Remove char
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      // Add char
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    // Insert txt into element
    this.txtElement.innerHTML = `<span class="txt">${this.txt}</span>`;

    // change color for data-text
    this.txtElement.innerHTML = `<span class="txt" style="color: #e2000f;">${this.txt}</span>`;

    // Initial Type Speed
    let typeSpeed = 100;

    if(this.isDeleting) {
      typeSpeed /= 2;
    }

    // If word is complete
    if(!this.isDeleting && this.txt === fullTxt) {
      // Make pause at end
      typeSpeed = this.wait;
      // Set delete to true
      this.isDeleting = true;
    } else if(this.isDeleting && this.txt === '') {
      this.isDeleting = false;
      // Move to next word
      this.wordIndex++;
      // Pause before start typing
      typeSpeed = 300;
    }

    setTimeout(() => this.type(), typeSpeed);
  }
}

$(document).ready(function () {

  setTimeout(function(){
    $('.product__info-wrapper .product-form__submit').removeClass('loading-btn');
  },1000);
  // let headerHeight = document.querySelector("header.header").clientHeight;
  let filterBarTop = null;
  // if(document.querySelector(".custom-filter-sticky")){
  //   filterBarTop = document.querySelector(".custom-filter-sticky").getBoundingClientRect().top;
  // }
  if(document.querySelector(".custom-filter-sticky")){
    filterBarTop = document.querySelector(".custom-filter-sticky").offsetTop;
  }
  $(window).scroll(function (){
    let headerHeight = document.querySelector("header.header").clientHeight;
    
    var sticky = $("header"),
    scroll = $(window).scrollTop();
    let allowStickyHeader = true;
    if(document.body.classList.contains("template-product") && document.body.clientWidth <= 749 ){
      allowStickyHeader = false;
    }
    if(allowStickyHeader){
      if(scroll >= 100){
        sticky.addClass("site-header--stuck");
        setTimeout(function(){
          sticky.addClass("site-header--opening");
          $(".collection-top").addClass("active");
        },100);
      }else{
        sticky.removeClass("site-header--stuck");
        setTimeout(function(){
          sticky.removeClass("site-header--opening");
          $(".collection-top").removeClass("active");
        },100);
      }
    }

    // filter bar sticky
    // if(document.body.classList.contains("template-collection") && document.querySelector(".custom-filter-sticky") && filterBarTop){
    //   if((scroll + headerHeight) >= filterBarTop){
    //     if(!document.querySelector(".custom-filter-sticky").classList.contains("sticky")){
    //       document.querySelector(".custom-filter-sticky").classList.add("sticky");
    //     }
    //   }else{
    //     if(document.querySelector(".custom-filter-sticky").classList.contains("sticky")){
    //       // document.querySelector(".custom-filter-sticky").classList.remove("sticky");
    //       document.querySelector(".custom-filter-sticky").classList.remove("sticky"); 
    //     }
    //   }
    // }
    // console.log("filterBarTop",filterBarTop,"headerHeight",headerHeight);
    if(document.body.classList.contains("template-collection") && document.querySelector(".custom-filter-sticky") && filterBarTop){
      if(scroll > (filterBarTop - headerHeight)){
        if(!document.querySelector(".custom-filter-sticky").classList.contains("sticky")){
          document.querySelector(".custom-filter-sticky").classList.add("sticky");
          document.querySelector(".custom-filter-sticky").style.setProperty('top', `${headerHeight}px`, 'important');
        }
      }else{
        if(document.querySelector(".custom-filter-sticky").classList.contains("sticky")){
          // document.querySelector(".custom-filter-sticky").classList.remove("sticky");
          document.querySelector(".custom-filter-sticky").classList.remove("sticky"); 
        }
      }
    }
    //coll page infinite scroll
    if (document.body.classList.contains("template-collection")){
      collpageInfiniteScroll();
    }
  });
  
  initHeaderSearch_textAnimation();

  // header shopby hover
  $(document).on("click", "[data-header-shopby]", function () {
  let type = $(this).attr("data-type");
  let $targetMenu = $(`#mega-menu-shopby-${type}`);
  let isAlreadyActive = $targetMenu.hasClass("megamenu-active");

  // Remove active class from all buttons and menus
  $("[data-header-shopby]").removeClass("active");
  $(".header-megamenu-shop").removeClass("megamenu-active");

  if (!isAlreadyActive) {
    // If it was not already open, open it and make current button active
    $(this).addClass("active");
    $targetMenu.addClass("megamenu-active");
  }
});

  $(document).on("mouseleave",".header-megamenu-shop",function(){
    $("[data-header-shopby]").removeClass("active");
    $(this).removeClass("megamenu-active");
  });
  // nav mobile menu
  if($(window).width() < 990){
    $(".header-center").insertAfter($(".header-top-wrapper"));
  }

  // in mobile - header collection slider
  headerMobileColl();

  // header drawer close click event
  let headerDrawerClose = document.querySelector("[data-custom-drawer-close]") || null;
  if(headerDrawerClose){
    headerDrawerClose.addEventListener("click",function(){
      document.querySelector(".main-details > summary").click();
    });
  }

  // START template -- index [ HOMEPAGE ]
  if (document.body.classList.contains("template-index")) {

    // section-main-banner-slideshow
    let homeSlider = document.querySelector(".cs-slideshow-main") || null;
    if(homeSlider){
      homeCustomSlideshow();
    }
    
    // section ==> scrolling-text.liquid
    var marqueeWrap = document.querySelector(".img_with_text_main") || null;
    if(marqueeWrap) {
      marqueeSlider();
    }

    // section ==> icon-with-text.liquid
    var iconTextMarqueeWrap = document.querySelector("[data-image-text-marquee]") || null;
    if(iconTextMarqueeWrap){
      iconTextMarquee();
    }

    // section ==> home-testimonial.liquid
    let homeTesti = document.querySelector(".home-testimonial-block .home-testimonial-slider") || null;
    if(homeTesti){
      homeTestiSlider();
    }
    
  }
  // END template -- index [ HOMEPAGE ]

  // START template -- product [ PRODUCT ]
  if (document.body.classList.contains("template-product")) {

    productMediaSlider();
    // product accordion inside btn's click
    $(document).on('click','.product__accordion .belt-tablinks',function(){
      var id = $(this).attr('id');
      $('.product__accordion .belt-tablinks').removeClass('belt-active');
      $(this).addClass('belt-active');
      $(".product__accordion .belt-tabcontent").hide();
      $(".product__accordion .belt-tabcontent[data-id='"+ id  +"']").show();
    });

    // section ==> product-testimonial.liquid
    let proTesti =  document.querySelector(".product-testimonial .product-testimonial-block") || null;
    if(proTesti){
      proTestimonial();
    }

    // preview btn
    let customilySticky = document.querySelector("[data-customily-preview]") || null;
    let count = 0;
    if($(window).width() < 990){

      let headerHeight = document.querySelector("header.header").clientHeight;
      // if(document.querySelector(".grid__item.product__media-wrapper")) document.querySelector(".grid__item.product__media-wrapper").style.top = (headerHeight - 7) + "px";
      if(document.querySelector(".grid__item.product__media-wrapper")) document.querySelector(".grid__item.product__media-wrapper").style.top = "0px";
      
      $(document).on("scroll",debounce(() => {
        let previewBtn = document.querySelector(".product-form .customily-preview-button") || null; // form preview btn -- app preview btn
        if(previewBtn && customilySticky){
          let sliderTop = document.querySelector(".product__media-list").getBoundingClientRect().y - 50;
          let scrollFromTop = window.pageYOffset;
          // console.log("scroll",sliderTop,scrollFromTop);
          if(sliderTop > scrollFromTop){
            customilySticky.classList.remove("show");
          }else{
            customilySticky.classList.add("show");
          }
          if(count == 0){
            // previewBtn && customilySticky
            customilySticky.addEventListener("click",function(e) {
              e.preventDefault();
              previewBtn.click();
            })
          }
          count++;

          // sticky slider
          if(window.pageYOffset > 0){
            document.body.classList.add("sticky-true");
            document.querySelector(".media-gallery-main").classList.add("media-gallery-sticky");
            document.querySelector(".product__media-wrapper").classList.add("main-sticky-div");
          }else{
            document.body.classList.remove("sticky-true");
            document.querySelector(".media-gallery-main").classList.remove("media-gallery-sticky");
            document.querySelector(".product__media-wrapper").classList.remove("main-sticky-div");
          }
          
        }
        
      }));
    }

    // data-hide-show-preview-btn
    let hideShowBtn = document.querySelector("[data-hide-show-preview-btn]") || null;
    if(hideShowBtn){
      hideShowBtn.addEventListener("click",function(e) {
        e.preventDefault();
        this.classList.toggle("preview-hidden");
        document.querySelector(".product__media-wrapper ").classList.toggle("sticky-button-hidden");
        // if(this.classList.contains("preview-hidden")){
        //   this.querySelector(".btn-text").innerHTML = "SHOW PREVIEW IMAGE";
        // }else{
        //   this.querySelector(".btn-text").innerHTML = "HIDE PREVIEW IMAGE";
        // }
        this.classList.contains("preview-hidden") ? this.querySelector(".btn-text").innerHTML = "SHOW PREVIEW IMAGE" : this.querySelector(".btn-text").innerHTML = "HIDE PREVIEW IMAGE";
        document.body.classList.toggle("hide-it");
      });
    }

    
    customilyPreview();
    
  }
  // END template -- product [ PRODUCT ]

  // START template -- collection [ COLLECTION ]
  if (document.body.classList.contains("template-collection") || document.querySelector(".section-collection-header")) {

    // add content height for banner
    let content = document.querySelector("[coll-banner-content]") || null;
    if(content && document.body.clientWidth <= 749){
      let height = content.clientHeight + 50;
      if(document.querySelector("[data-collection-banner] .video-wrap")){
        document.querySelector("[data-collection-banner] .video-wrap img.mobile").style.height = `${height}px`;
      }else{
        document.querySelector("[data-collection-banner] .tr-collection-pg-tp-bnr-inn img.mobile").style.height = `${height + 20}px`;
      }
    }

    // section ==> collection-grid.liquid
    let collGrid =  document.querySelector("[data-collection-grid-slider]") || null;
    if(collGrid){
      collGridSlider();
    }

    // section ==> collection-featured-collection.liquid
    let collfeaturedColls =  document.querySelector("[data-coll-featured-slider]") || document.querySelector("[data-coll-products-slider]");
    if(collfeaturedColls){
      collfeaturedSliders();
    }

    // special-offer-popup JS
    let specialOfferPopupClose = document.querySelectorAll("[data-sf-close-btn],[data-sf-popup-overlay]");
    if(specialOfferPopupClose.length){
      document.body.classList.add("overflow-hidden");
    }
    specialOfferPopupClose.forEach(ele => {
      ele.addEventListener("click",function(e){
        e.preventDefault();
        if(ele.closest(".special-offer-popup")){
          ele.closest(".special-offer-popup").classList.remove("active");
          document.body.classList.remove("overflow-hidden");
        }
      });
    });
    
  }
  // END template -- collection [ COLLECTION ]

  // START template -- faq [ FAQ ]
  // faq que-ans
  $(document).on('click','[data-faq-main] [data-faq-que]',function(){
    $(this).parent("[data-single-faq]").siblings().removeClass("active").find("[data-faq-ans]").slideUp();
    $(this).parent("[data-single-faq]").toggleClass("active").find("[data-faq-ans]").slideToggle();
  });
  // END template -- faq [ FAQ ]

  // START template -- fantasy-football-landing
  if (document.body.classList.contains("template-fantasy-football-landing")) {
    
    // section ==> fantasy-feature-product.liquid
    var fantasyFeature = document.querySelector("[data-fantasy-products-slider]") || null;
    if(fantasyFeature) {
      fantasyFeatureSlider();
    }

    // section ==> fantasy-featured-collection.liquid
    var featuredColl = document.querySelector("[data-fantasy-featured-slider]") || null;
    if(featuredColl) {
      fantasyfeaturedCollSlider();
    }

    // section ==> scrolling-text.liquid
    var marqueeWrap = document.querySelector(".img_with_text_main") || null;
    if(marqueeWrap) {
      marqueeSlider();
    }
    
    // section ==> icon-with-text.liquid
    var iconTextMarqueeWrap = document.querySelector("[data-image-text-marquee]") || null;
    if(iconTextMarqueeWrap){
      iconTextMarquee();
    }

    // section ==> home-testimonial.liquid
    let homeTesti = document.querySelector(".home-testimonial-block .home-testimonial-slider") || null;
    if(homeTesti){
      homeTestiSlider();
    }

    // fantasy tabs ans faqs - data-fantasy-faq-wrapper
    $(document).on('click','[data-fantasy-faq-wrapper] button.tablinks',function(){
      let id = $(this).attr("data-id");
      $(this).addClass("active").siblings().removeClass("active");
      $("[data-fantasy-faq-wrapper] .tabcontent").fadeOut().removeClass("active");
      $(`[data-fantasy-faq-wrapper] .tabcontent#${id}`).addClass("active").fadeIn();
    });
    $(document).on('click','[data-fantasy-faq-wrapper] .tabcontent button',function(){
      let handle = $(this).attr("data-handle");
      $(this).siblings().removeClass("active").filter(`.fflp-panel:not(#${handle})`).slideUp();
      $(this).toggleClass("active");
      $(`[data-fantasy-faq-wrapper] .tabcontent #${handle}`).slideToggle();
    });
  }
  // END template -- fantasy-football-landing


  // START template -- template-landing
  if (document.body.classList.contains("template-landing")) {

    jQuery(window).scroll(function(){
      var footer_offset = jQuery('[data-landing-loser]').offset().top;
      var scrollTop = jQuery(window).scrollTop() + jQuery(window).height() - 50;
      if(scrollTop >= footer_offset){
        jQuery('.landing-losers-title').addClass('active');
      }
    });
  }
  // END template -- template-landing

    //page template image with product silder code start here
if (
  document.body.classList.contains("template-page") &&
  document.querySelector("[data-image-with-slider]")
) {

  const proSlider = document.querySelector("[data-image-with-slider]");

  if (proSlider) {
    imageWithSlider();
  }

  $("a.scroll-next").on('click', function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      const hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 215
      }, 800);
    }
  });

  $("[data-btn-load-more]").on("click", function (event) {
    event.preventDefault();
    $(".page-product-collection ul .grid__item.hide-default")
      .slice(0, 5)
      .removeClass("hide-default");

    if ($(".page-product-collection ul .grid__item.hide-default").length === 0) {
      $(this).addClass("hidden");
    }
  });

}
  //page template image with product silder code end here
  
  // START template -- template-products || template-sharktank || template-yahoo
  if (document.body.classList.contains("template-products") || document.body.classList.contains("template-sharktank") || document.body.classList.contains("template-yahoo") || document.body.classList.contains("template-ladies-league")|| document.body.classList.contains("template-cbs") || document.body.classList.contains("template-team-name-generator")) {

    // section ==> image-with-slider.liquid
    var proSlider = document.querySelector("[data-image-with-slider]") || null;
    if(proSlider){
      imageWithSlider();
    }
    
    // new WOW().init();
    $("a.scroll-next").on('click', function (event) {
      if (this.hash !== "") {
        event.preventDefault();
        var hash = this.hash;
        $('html, body').animate({
          scrollTop: $(hash).offset().top - 215
        }, 800);
      } // End if
    });
    $("[data-btn-load-more]").on("click",function (event) {
      event.preventDefault();
      $(".page-product-collection ul .grid__item.hide-default").each(function(index,item){
        if(index < 5){
          $(item).removeClass("hide-default");
        }
      });
      if($(".page-product-collection ul .grid__item.hide-default").length == 0){
        $(this).addClass("hidden");
      }
    });
  }
  // END template -- template-products || template-sharktank || template-yahoo

  // START template -- template-article
  if (document.body.classList.contains("template-article")) {
    $(".article-template__content img").each((index,item) => {
      let src = $(item).attr("data-src");
      if(!$(item).attr("src") && src != "undefined"){
        $(item).attr("src",src);
      }
    });
      
  }
  // END template -- template-article
// START template -- template-yahoo-commish
if (document.body.classList.contains("template-yahoo-commish") ) {

  // section ==> image-with-slider.liquid
  var proSlider = document.querySelector("[data-image-with-slider]") || null;
  if (proSlider) {
    imageWithSlider();
  }

  // Smooth scroll
  $("a.scroll-next").on('click', function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 215
      }, 800);
    }
  });

  // Load more 10 products
  $("[data-btn-load-more]").on("click", function (event) {
    event.preventDefault();

    $(".page-product-collection ul .grid__item.hide-default").each(function (index, item) {
      if (index < 10) {
        $(item).removeClass("hide-default");
      }
    });

    if ($(".page-product-collection ul .grid__item.hide-default").length === 0) {
      $(this).addClass("hidden");
    }
  });

}
// START template -- template-warehouse-sale
if (document.body.classList.contains("template-warehouse-sale") ) {

  // section ==> image-with-slider.liquid
  var proSlider = document.querySelector("[data-image-with-slider]") || null;
  if (proSlider) {
    imageWithSlider();
  }

  // Smooth scroll
  $("a.scroll-next").on('click', function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 215
      }, 800);
    }
  });

  // Load more 10 products
  $("[data-btn-load-more]").on("click", function (event) {
    event.preventDefault();

    $(".page-product-collection ul .grid__item.hide-default").each(function (index, item) {
      if (index < 10) {
        $(item).removeClass("hide-default");
      }
    });

    if ($(".page-product-collection ul .grid__item.hide-default").length === 0) {
      $(this).addClass("hidden");
    }
  });

}
// END template -- template-warehouse-sale
  // START template -- template-about_us
  if (document.body.classList.contains("template-about_us")) {

    // view all team btn click
    $(document).on("click","[data-view-all-team-btn]",function(e){
      e.preventDefault();
      $(".team__wrapper .team-member:nth-child(n+17)").fadeIn();
      $(this).hide();
    });
  }
  // END template -- template-about_us


  function headerMobileColl(){
    $('.header-mobile-collection .header-mob-coll').slick({
      dots:false,
      infinite: true,
      slidesToShow: 1,
      variableWidth: true,
            responsive: [
          {
            breakpoint: 480,
            settings: {
               variableWidth:false,
              slidesToShow: 4,
              slidesToScroll: 4,
              arrows: true,
              swipeToSlide: true
            }
          }
        ]
    });
  }
  
  function homeTestiSlider() {
    $('.home-testimonial-block .home-testimonial-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }
  
  function homeCustomSlideshow() {
    $('.cs-slideshow-main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      dots: true,
      adaptiveHeight:false
    });
    var interval;
    function displayText(slide) {
      var slideTextElements = slide.querySelectorAll('.slide_text div');
      if(slideTextElements.length > 1){
        var slide_text = slide.querySelector(".fs_slide_text_loop_text");
        var index = 0;
        setInterval(function() {
          if(slide_text) slide_text.innerHTML = slideTextElements[index].innerHTML.trim();
          index++;
          if (index >= slideTextElements.length) {
              index = 0; // Reset index to 0 when reaching the end
          }
        }, 1000);
      }else{
        var slide_text = slide.querySelector(".fs_slide_text_loop_text");
        if(slide_text) slide_text.innerHTML = slideTextElements[0].innerHTML.trim();
      }
      return interval;
    }

    document.querySelectorAll(".cs-slideshow-main .cs-slideshow-item").forEach(slide => {
      displayText(slide);
    });
  }
  
  $('.fpc-slideshow-wrap').slick({
    dots:false,
    infinite: true,
    slidesToShow: 6,
    responsive: [
      {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        }
      }
    ]
  });
  
  
  function marqueeSlider() {
    $('.img_with_text_main').slick({
      dots: true,
      infinite: true,
      speed: 16000,
      autoplaySpeed: 0,
      autoplay: true,
      variableWidth: true,
      cssEase: 'linear',
      arrows: false,
      dots: false,
        responsive: [
        {
          breakpoint: 749,
          settings: {
             variableWidth:false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true
          }
        }
      ]
    });
  }
  
  function iconTextMarquee(){
    $("[data-image-text-marquee]").slick({
      speed: 8000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: false,
      cssEase: 'linear',
      slidesToShow: 1,
      draggable:false,
      focusOnSelect:false,
      pauseOnFocus:false,
      pauseOnHover:false,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false
    });
  }
  
  function productMediaSlider() {
    // this is for default design : bottom side thumbnail slider
    $("[data-main-slider-default] .product__media-list").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable:false,
      adaptiveHeight: true,
      arrows: true,
      asNavFor: "[data-thumb-slider-default] .thumbnail-list",
      infinite: true,
      responsive: [
        {
        breakpoint: 991,
        settings: {
            dots: true
          }
        }
      ]
    });
    $("[data-thumb-slider-default] .thumbnail-list").slick({
      asNavFor: "[data-main-slider-default] .product__media-list",
      slidesToShow: 5,
      dots: false,
      arrows: false,
      focusOnSelect: true,
      infinite: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
              dots: true
            }
        }
      ]
    });
  
    // this is for vertical left side thumbnail slider
    $("[data-main-slider] .product__media-list").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      draggable:false,
      adaptiveHeight: true,
      asNavFor: "[data-thumb-slider] .thumbnail-list",
      responsive: [
        {
          breakpoint: 991,
          settings: {
              dots: true
            }
        }
      ]
    });
    // let checkInfiite = true;
    // if(document.body.classList.contains("template-bs-wall-plaques")) checkInfiite = false;
    $("[data-thumb-slider] .thumbnail-list").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: "[data-main-slider] .product__media-list",
      dots: false,
      arrows: true,
      vertical: true,
      verticalSwiping: true,
      centerMode: false,
      focusOnSelect: true,
      infinite:false,
      prevArrow: "<button class='slider-arr thumb-prev'><</button>",
      nextArrow: "<button class='slider-arr thumb-next'>></button>"
    });
  }
  
  function collGridSlider() {
    $("[data-collection-grid-slider]").slick({
      slidesToShow: 10,
      slidesToScroll: 1,
      // dots: false,
      arrows: true,
      // focusOnSelect: true,
      infinite: false,
      prevArrow: "<button class='slider-arr slider-prev'><</button>",
      nextArrow: "<button class='slider-arr slider-next'>></button>",
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 5
            // slidesToScroll: 5
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 4
            // slidesToScroll: 4
          }
        }
      ]
    });
  }
  
  function collfeaturedSliders() {
    $("[data-coll-products-slider]").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      arrows: true,
      focusOnSelect: true,
      infinite: true,
      prevArrow: "<button class='slider-arr slider-prev'><</button>",
      nextArrow: "<button class='slider-arr slider-next'>></button>",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    
    $("[data-coll-featured-slider]").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      arrows: true,
      focusOnSelect: true,
      infinite: true,
      prevArrow: "<button class='slider-arr slider-prev'><</button>",
      nextArrow: "<button class='slider-arr slider-next'>></button>",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  }
  
  function proTestimonial() {
    $('.product-testimonial .product-testimonial-block').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });
  }
  
  function fantasyFeatureSlider(){
    $("[data-fantasy-products-slider]").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      arrows: true,
      focusOnSelect: true,
      infinite: true,
      prevArrow: "<button class='slider-arr slider-prev'><</button>",
      nextArrow: "<button class='slider-arr slider-next'>></button>",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  
  function fantasyfeaturedCollSlider() {
    $("[data-fantasy-featured-slider]").each(function(index,item){
      $(item).slick({
        slidesToShow: parseInt($(item).attr("data-slide-to-show")),
        // slidesToScroll: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        focusOnSelect: true,
        infinite: true,
        prevArrow: "<button class='slider-arr slider-prev'><</button>",
        nextArrow: "<button class='slider-arr slider-next'>></button>",
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2
              // slidesToScroll: 2
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1
              // slidesToScroll: 1
            }
          }
        ]
      });
    });
  }
  
  function imageWithSlider() {
    $("[data-image-with-slider]").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      focusOnSelect: true,
      infinite: false,
      prevArrow: "<button class='slider-arr slider-prev'><</button>",
      nextArrow: "<button class='slider-arr slider-next'>></button>",
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2
            // slidesToScroll: 2
          }
        }
      ]
    });
  }
  
  function customilyPreview(){
    // add ADD TO CART btn at bottom of app preview popup
    window.addEventListener('customily-options-loaded', function() {
      // console.log(">>>>>>>>LOADED",document.querySelector(".customily-modal-preview-only"));
      let previewBtn = document.querySelector("#customily-preview-button") || null;
      
     // start code for button text change replace to uplaod
//       let update_Btn = document.querySelector(".customily-download-button") || null;

//    if (update_Btn) {
//     // Function to update button text while keeping the icon
//     function updateButtonText() {
//         const iconHTML = update_Btn.querySelector('svg') ? update_Btn.querySelector('svg').outerHTML : '';
//         // Set the button's innerHTML to keep the icon and change the text to "UPLOAD"
//         update_Btn.innerHTML = `${iconHTML} UPLOAD`;
//     }

//     // Create a MutationObserver to monitor changes to the button's content
//     const observer = new MutationObserver(() => {
//         // Temporarily disconnect the observer to avoid infinite loops
//         observer.disconnect();
//         // Reset the button content
//         updateButtonText();
//         // Reconnect the observer after making the change
//         observer.observe(update_Btn, { childList: true, subtree: true });
//     });
//     updateButtonText();

//     // Start observing the button for changes to its child elements
//     observer.observe(update_Btn, { childList: true, subtree: true });
// }
      // end code for button text change replace to uplaod

      if(previewBtn){
        let btn = document.createElement("button");
        btn.classList.add("custom-preview-btn");
        btn.innerText = "Preview";
        previewBtn.closest(".product-form__buttons").insertBefore(btn,previewBtn);
        btn.addEventListener("click",function(e){
          e.preventDefault();
          previewBtn.click();
          setTimeout(()=> {
            let previewWrap = document.querySelector(".customily-modal-preview-only") || null;
            if(previewWrap){
              // console.log("previewWrap",previewWrap);
              if(!previewWrap.querySelector(".custom-add-to-cart")){
                let a2cBtn = document.createElement("button");
                a2cBtn.classList.add("custom-add-to-cart");
                a2cBtn.innerText = "Add to Cart";
                // console.log("a2cBtn",a2cBtn);
                previewWrap.querySelector(".cl-preview-wrapper").insertBefore(a2cBtn, previewWrap.querySelector(".cl-preview-wrapper .cl-preview-image").nextSibling);
                a2cBtn.addEventListener("click",function(e){
                  e.preventDefault();
                  document.querySelector("#customily-cart-btn").click();
                  previewWrap.querySelector(".customily-close-button").click();
                });
              }
            }
          },200);
        });
      }
    });
  }
  
  // Init header search input text animation
  function initHeaderSearch_textAnimation() {
    const txtElement = document.querySelector('.txt-type');
    const words = JSON.parse(txtElement.getAttribute('data-words'));
    const wait = txtElement.getAttribute('data-wait');
    // Init TypeWriter
    new TypeWriter(txtElement, words, wait);
  }

  //purchasing-account page form hide show script: Start
  $("body").on("click", ".account_link", function(e){
    e.preventDefault();
    $("#forms_inline_p8L6RA").hide();
    $("#forms_inline_Agzwp3").hide();
    $("#forms_inline_qbYFAV").hide();
    
    let formId = $(this).attr("href"); 
    if( formId !="" ){
      $(formId).show();
      //let width = screen.width;
      // if( width <= 768 ){      
      //   console.log("Mobile");
      //   $('html, body').animate({
      //       scrollTop: $(formId).offset().top - 200
      //   }, 550);
      // }
    }    
  });

    
  let temp = 0;
  function collpageInfiniteScroll(){
    if($("button.load-more:not(.disabled)").length){
      let a = isScrolledIntoView($("button.load-more:not(.disabled)"));
      // console.log("a",a);
      if(a == true)
      {
      if(temp == 0){
        // console.log("btn clicked");
        document.querySelector("[data-load-more]").click();
        // $("#ProductGridContainer #AjaxinatePagination .pagination__item").trigger("click");
        // getData(); // in global.js [ for multiple use ]
        temp = 1;
      }
      }else{
        // console.log("prevent clicked");
        temp = 0;
      }
    }
    function isScrolledIntoView(elem){
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();
      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();
      return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }
  }
});
// document ready -- end

/* ***This will only render in the theme editor / customiser***** */
if (Shopify.designMode) {
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("shopify:section:load", function () {

      // section-main-banner-slideshow
      let homeSlider = event.target.closest(".cs-slideshow-main") || null;
      if(homeSlider){
        homeCustomSlideshow();
      }

      // in mobile - header collection slider
      let headerCollSlider = event.target.closest(".header-mobile-collection ul") || null;
      if(headerCollSlider){
        headerMobileColl();
      }    

      // section ==> home-testimonial.liquid
      let homeTesti = event.target.closest(".home-testimonial-block .home-testimonial-slider") || null;
      if(homeTesti){
        homeTestiSlider();
      }
      
      // section ==> scrolling-text.liquid
      let marqueeWrap = event.target.closest(".img_with_text_main") || null;
      if(marqueeWrap){
        marqueeSlider();
      }

      // section ==> product-testimonial.liquid
      let proTesti =  event.target.closest(".product-testimonial .product-testimonial-block") || null;
      if(proTesti){
        proTestimonial();
      }

      // section ==> perpetual-main-product.liquid
      let proSlider =  event.target.closest(".product [data-main-slider]") || null;
      if(proSlider){
        productMediaSlider();
      }

      // section ==> fantasy-feature-product.liquid
      let fantasyFeature = event.target.closest("[data-fantasy-products-slider]") || null;
      if(fantasyFeature) {
        fantasyFeatureSlider();
      }

      // section ==> collection-grid.liquid
      let collGrid =  event.target.closest("[data-collection-grid-slider]") || null;
      if(collGrid){
        collGridSlider();
      }

      // section ==> collection-featured-collection.liquid
      let collfeaturedColls =  documentevent.target.closest("[data-coll-featured-slider]") || document.querySelector("[data-coll-products-slider]");
      if(collfeaturedColls){
        collfeaturedSliders();
      }

    });
  });
}
$(document).ready(function(){
      $('.about-us-img-with-text').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      });
    });
// don't add any js here at the end - [ add jS above designMode ]